<script setup>
import Toast from 'primevue/toast'

const SEVERITY_STYLES = {
    success: {
        icon: 'pi pi-check-circle',
        box: 'bg-emerald-50 border-emerald-200 text-emerald-800 dark:bg-emerald-500/10 dark:border-emerald-500/30 dark:text-emerald-300',
        icon_color: 'text-emerald-500 dark:text-emerald-400',
    },
    error: {
        icon: 'pi pi-times-circle',
        box: 'bg-red-50 border-red-200 text-red-800 dark:bg-red-500/10 dark:border-red-500/30 dark:text-red-300',
        icon_color: 'text-red-500 dark:text-red-400',
    },
    warn: {
        icon: 'pi pi-exclamation-triangle',
        box: 'bg-amber-50 border-amber-200 text-amber-800 dark:bg-amber-500/10 dark:border-amber-500/30 dark:text-amber-300',
        icon_color: 'text-amber-500 dark:text-amber-400',
    },
    info: {
        icon: 'pi pi-info-circle',
        box: 'bg-blue-50 border-blue-200 text-blue-800 dark:bg-blue-500/10 dark:border-blue-500/30 dark:text-blue-300',
        icon_color: 'text-blue-500 dark:text-blue-400',
    },
}

function styleFor(severity) {
    return SEVERITY_STYLES[severity] || SEVERITY_STYLES.info
}
</script>

<template>
    <Toast position="top-center">
        <template #container="{ message, closeCallback }">
            <div
                class="flex items-start gap-3 w-full max-w-sm rounded-xl border shadow-lg shadow-black/5 px-4 py-3"
                :class="styleFor(message.severity).box"
            >
                <i
                    class="text-lg leading-none mt-0.5 flex-shrink-0"
                    :class="[styleFor(message.severity).icon, styleFor(message.severity).icon_color]"
                ></i>
                <div class="flex-1 min-w-0">
                    <div v-if="message.summary" class="text-sm font-semibold leading-tight">
                        {{ message.summary }}
                    </div>
                    <div v-if="message.detail" class="text-sm leading-snug opacity-90" :class="{ 'mt-0.5': message.summary }">
                        {{ message.detail }}
                    </div>
                </div>
                <button
                    class="flex-shrink-0 opacity-50 hover:opacity-100 transition-opacity"
                    @click="closeCallback"
                >
                    <i class="pi pi-times text-xs"></i>
                </button>
            </div>
        </template>
    </Toast>
</template>

<style lang="scss">
// Toast se přes <Portal> teleportuje mimo strom komponenty, takže scoped :deep()
// na něj spolehlivě nedosáhne — proto je tohle globální (nescoped) pravidlo.
// #container slot nahrazuje jen obsah zprávy, PrimeVue/Aura ale pořád kreslí kolem
// vlastní .p-toast-message wrapper (barevná karta se stínem/rámečkem podle
// severity), který pak "prosvítal" zpoza našeho vlastního designu.
.p-toast-message {
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    border-radius: 0 !important;
}

.p-toast-message-content {
    padding: 0 !important;
}
</style>
